<template>
    <!-- eslint-disable -->
    <div class="chatbot card" style="width: 100%; opacity: 1; border: none; padding: 0px;  z-index: 1;" >
  
        <div style="width: 100%; opacity: 1; border: none; display: flex;  justify-content: center; z-index: -1; ">
            <div class="col-xl-10 mb-5 mb-xl-5"  ref='messageDisplay' id="messageDisplay" 
                style="padding: 0px; opacity: 1; overflow-y: scroll; position: fixed; bottom: 0; max-height: 850px;">
                <card type="default" header-classes="bg-transparent">
                    <div class="card-body"  style="padding: 0px; opacity: 1;">
                
                        <div class="" style="" v-for="(item, index) in menssagens" :key="index">
                            <!-- Div Paciente -->
                            <div style="display: flex; justify-content: flex-end;" v-if="item.id">
                                <div style="background: #e0e0e0; margin: -10px 0px 0px 0px; mix-width: 600px; border-radius: 10px 0px 10px 10px; -moz-border-radius: 10px 0px 10px 10px; -webkit-border-radius: 10px 0px 10px 10px;">
                                    <div class="text-cliente" style="color: #656565;" v-html="item.dados.msg"></div>
                                </div>
                            </div>

                            <!-- Div Bot -->
                            <div style="display: flex; justify-content: flex-start;" v-else>
                                <img src="/img/Sam.jpg" class="rounded-circle float-start" style="width: 50px; height: 50px; margin: 2px 10px 0px 2px; -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);">
                                <div style="opacity: 1; margin: 20px 0px 60px 0px;">
                                    <div class="text-bot" v-html="item.dados.msg"></div>
                                </div>
                            </div>
                        </div>

                        <div class="" v-if="loading">
                            <div style="display: flex; justify-content: flex-start;">
                                <img src="/img/Sam.jpg" class="rounded-circle float-start" style="width: 50px; height: 50px; margin: 2px 10px 0px 2px; -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
-moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);">
                                <div style="opacity: 1; margin: -10px 0px 60px 0px;">
                                    <div class="text-bot">Aguarde...</div>
                                </div>
                            </div>   
                        </div>


                        <div v-if="dadosBot.disponivelApartirDe" class="alert alert-success" role="alert">
                            Disponível a partir de <strong>{{dadosBot.disponivelApartirDe}}</strong>
                        </div>

                    </div>
                </card>
            </div>
        </div>

         <!-- <ul class="lista-msg" ref='messageDisplay' id="messageDisplay">
            <li class="lista-item" v-for="(item, index) in menssagens" :key="index">-->
                <!--DIV DO CLIENTE-->
                <!-- <div class="item-msg row m-0 p-2" v-if="item.id">
                    <div class="col-6">
                    </div>
                    <div class="col-6 text-right">
                        <div class="text-cliente" v-html="item.dados.msg"></div>
                    </div>                
                    
                </div>  -->

                <!---DIV DO BOT--->
                <!-- <div class="item-msg row m-0 p-2" v-else>
                    <div class="col-md-1 col-lg-1" > 
                        <img src="/img/chatbot.svg" class="rounded mx-auto d-none d-sm-block" width="30"/>
                    </div>
                    <div class="col-md-10 col-lg-6 text-left">
                        <div class="text-bot" v-html="item.dados.msg"> </div>
                    </div>                    
                </div>                

            </li>

            <li class="lista-item" v-if="loading">
               <div class="item-msg row m-0 p-2">
                    <div class="col-md-1 col-lg-1" > 
                        <img src="/img/chatbot.svg" class="rounded mx-auto d-none d-sm-block" width="30"/>
                    </div>
                    <div class="col-md-10 col-lg-6 text-left">
                        <div class="text-bot text-center"> <h1>...</h1> </div>
                    </div>                    
                </div>    
            </li>
            
        </ul> -->


        <div class="rodape" style="position: fixed; bottom: 0; margin-left: -0px; background: #e9e9e9; padding: 5px 0px 5px 0px;" v-show="!disabled">

            <div style="min-width: 300px; display: flex; justify-content: center;" v-if="campo === 0">
                <button type="button" class="btn btn-success btninput btn-inicial" @click="redirect()" :disabled="disabled">1</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(2)" :disabled="disabled">2</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(3)" :disabled="disabled">3</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(4)" :disabled="disabled">4</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(5)" :disabled="disabled">5</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(6)" :disabled="disabled">6</button>
                <!-- <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(7)" :disabled="disabled">7</button> -->
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center;" v-else-if="campo === 1">
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(1)" :disabled="disabled">SIM</button>
                <button type="button" class="btn btn-danger btninput" @click="enviarResposta(2)" :disabled="disabled">NÃO</button>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 2">
                <form class="user d-flex" v-on:submit.prevent="enviarResposta(resposta2)" style="width: 95%;">
                   
                        <the-mask :mask="valorMask" type="text" class="form-control inputEnviar" :masked="masked" :placeholder="placeholder" v-model="resposta2"></the-mask>
                        <button class="btn btn-success btnEnviar" type="submit">Enviar</button>

                </form>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center;" v-else-if="campo === 3">
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(1)" :disabled="disabled">1</button>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="enviarResposta(2)" :disabled="disabled">2</button>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 4">
                <form class="user d-flex" v-on:submit.prevent="escolherDia(resposta3)" style="width: 95%;">
                   
                        <the-mask :mask="valorMask" type="text" class="form-control inputEnviar" :masked="masked" :placeholder="placeholder" v-model="resposta3"></the-mask>
                        <button class="btn btn-success btnEnviar" type="submit">Enviar</button>
                        
                </form>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 5">
                        <select class="custom-select" aria-label="Default select example" v-model="respostaSelect" style="width: 98%; max-height: 40px; margin: 7px 5px 0px 5px; font-size: 18px; font-family: Roboto;">
                            <option disabled="disabled" value selected="selected">Selecione aqui...</option>
                            <option v-for="item in listaEspecialidade" :key="item.id" :value="item.id" >{{item.descricao}}</option>
                        </select>

                        <button type="button" class="btn btn-danger btnEnviar" @click="enviarResposta(respostaSelect)">
                            Enviar
                        </button>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 6">
                        <select class="custom-select" aria-label="Default select example" v-model="respostaSelectDadosAgenda" style="width: 98%; max-height: 40px; margin: 7px 5px 0px 5px; font-size: 18px; font-family: Roboto;">
                            <option disabled="disabled" value selected="selected">Selecione aqui...</option>
                            <option v-for="item in dadosAgenda" :key="item.idAgenda" :value="item.idAgenda" >{{item.nome}} - UNIDADE: {{item.unidade.descricao}}</option>
                        </select>

                        <button type="button" class="btn btn-danger btnEnviar" @click="enviarResposta(respostaSelectDadosAgenda)">
                            Enviar
                        </button>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 7">
                        <select class="custom-select" aria-label="Default select example" v-model="respostaSelectDatasDisponiveisAgenda" style="width: 98%; max-height: 40px; margin: 7px 5px 0px 5px; font-size: 18px; font-family: Roboto;">
                            <option disabled="disabled" value selected="selected">Selecione aqui...</option>
                            <option v-for="item in datasDisponiveisAgenda" :key="item" :value="item" >{{item}}</option>
                        </select>

                        <button type="button" class="btn btn-danger btnEnviar" @click="enviarResposta(respostaSelectDatasDisponiveisAgenda)" >
                            Enviar
                        </button>
            </div>

            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 8">
                        <select class="custom-select" aria-label="Default select example" v-model="respostaSelectHoraDia" style="width: 98%; max-height: 40px; margin: 7px 5px 0px 5px; font-size: 18px; font-family: Roboto;">
                            <option disabled="disabled" value selected="selected">Selecione aqui...</option>
                            <option v-for="item in horaDia" :key="item" :value="item" >{{item}}</option>
                        </select>

                        <button type="button" class="btn btn-danger btnEnviar" @click="enviarResposta(respostaSelectHoraDia)" >
                            Enviar
                        </button>
            </div>

            <!-- //EXAME -->
            <div style="min-width: 300px; display: flex; justify-content: center; padding: 0px 0px 5px 0px;" v-else-if="campo === 9">
                        <select class="custom-select" aria-label="Default select example" v-model="respostaTipoExame" style="width: 98%; max-height: 40px; margin: 7px 5px 0px 5px; font-size: 18px; font-family: Roboto;">
                            <option disabled="disabled" value selected="selected">Selecione aqui...</option>
                            <option v-for="item in tipoExame" :key="item.id" :value="item.id">{{item.descricao}}</option>
                        </select>

                        <button type="button" class="btn btn-danger btnEnviar" @click="enviarResposta(respostaTipoExame)" >
                            Enviar
                        </button>
            </div>

            


            <div style="min-width: 300px; display: flex; justify-content: center;"  v-else>
                <button type="button" class="btn btn-success btninput btn-inicial" @click="reload()">Voltar</button>
            </div>

        </div>

       
<!-- 
        <ul>
            <li v-for="item in dadosAgenda" :key="item.id">
                {{item.id}} - {{item.nome}}
            </li>
        </ul> -->

    
  </div>
</template>

<script>
/* eslint-disable */
import io from 'socket.io-client'
import {TheMask} from 'vue-the-mask'
import moment from 'moment'

export default {
    name: "ChatBot",  
    components: {TheMask},
    data() {
        return {
            respostaSelect: "",
            respostaSelectDadosAgenda: "",
            respostaSelectDatasDisponiveisAgenda: "",
            respostaSelectHoraDia: "",
            respostaTipoExame: "",
            campo: 0,
            yesHoNo: false,
            voltarShow: false,
            placeholder: "",
            disabled: false,
            caminho: 0,
            cont: 0,
            valorMask: "###.###",
            masked: false,
            //socket: io('http://localhost:3001'),
            socket: io('https://api-stream-telemedicina.samel.com.br/'),
            // socket: io('http://192.168.6.104:8102/'),
            dadosConexao: null,
            resposta: 6,
            resposta2: 6,
            resposta3: 6,
            dadosAgenda: [],
            menssagens: [{dados:{
                            msg:`
                            <h5>Olá, em que posso ajudar?</h5>            
                            </p>Digite o <b>número</b> correspondente a opção:
                            </p>
                            <p><b>1</b>: Atendimento Telemedicina</p>
                            <p><b>2</b>: Agendar Consultas</p>
                            <p><b>3</b>: Agendar Exames</p>
                            <p><b>4</b>: Cancelar Consultas</p>
                            <p><b>5</b>: Cancelar Exames</p>
                            <p><b>6</b>: Listar Unidades</p>
                            `,
                            menu: 0,
                            input: '',
                            finalizou: false
                        }}],
            loading: false,
            cliente: null,
            dadosBot:{
                tipo: null,
                dataNascimento: "",
                idadeCliente: "",
                cpf: "",
                nome: "",
                tele_and_presencial: 0,
                cdPessoaFisica: 0,
                sexo: "",
                especialidade: 0,
                idCliente: "",

                nomeMedico: "",
                idAgenda: 0,
                idProfissional: 0,
                dataAgenda: "",
                dataAgenda2: "",
                dataSelecionada: "",
                horaSelecionada: "",
                dataHora: "",
                codigoCarteirinha: "",
                idEmpresa: "",
                disponivelApartirDe: "",

                exameId: "",
                exameDescricao:"",
                exameDescricaoPreparo: "",
                
            },
            dadosCovid: [],
            listaEspecialidade: [],
            datasDisponiveisAgenda: [],
            datasGeral: [],
            horaDia: [],
            tipoExame: [],

            paciente:{
                idEspecialidade: 0,
                nomeProfissional: "",
                idCliente: "",
            }
        }
    },
    
    mounted(){

        let id = Math.floor(1000000000 + Math.random() * 9000000000)

         let dados = {
            nome: "usuario-"+id, //gera um numero aleatorio
            id: "usuario-"+id,
            sala: "sala"+id,
        }

        this.dadosConexao = dados

        this.socket.emit('join-bot', dados, function () {})  
        this.escutarMensagens()
        
    },
    methods: {
        redirect(){
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ){
                funcaoAlert("https://apps.apple.com/br/app/samel-assist%C3%AAncia-medica/id1475154859")//IOS
            }
            else if( userAgent.match( /Android/i ) ){
                funcaoAlert("https://play.google.com/store/apps/details?id=com.appsamelv3")//Android
            }
            else{
                funcaoAlert("https://agendamento-online.samel.com.br/#/login")
            }

            function funcaoAlert(url){
                var r = confirm("Agora você pode agendar sua consulta pelo App, baixe o aplicativo, faça seu cadastro e agende sua consulta Telemedicina!");
                if (r == true){
                    window.location = url;
                }else{
                    window.location = url;
                }
            }
        },
        moment: function (data) {
        return moment(data);
        },
        reload(){
            location.reload();
        },

        pushMenssagens(data){
            //Menssagens lado Paciente
            if(data.id){
                switch(data.dados.menu){
                    case 24:
                        let cont1 = 0;
                        this.listaEspecialidade.map(dado => {
                            if(dado.id == data.dados.msg){
                                if(dado.id == 111 && cont1 == 0){
                                    cont1 ++;
                                    var  varListaEspecialidade =  {
                                        dados : {
                                            msg: "Ambulatório",
                                            menu: data.dados.menu,
                                            input: data.dados.input,
                                            finalizou: data.dados.finalizou
                                            },
                                        id: data.id,
                                        resposta: data.resposta,
                                        sala: data.sala
                                    }
                                    this.menssagens.push(varListaEspecialidade)
                                }if(dado.id != 111 && cont1 == 0){
                                    var  varListaEspecialidade =  {
                                        dados : {
                                            msg: dado.descricao,
                                            menu: data.dados.menu,
                                            input: data.dados.input,
                                            finalizou: data.dados.finalizou
                                            },
                                        id: data.id,
                                        resposta: data.resposta,
                                        sala: data.sala
                                    }
                                    this.menssagens.push(varListaEspecialidade)                                      
                                    
                                }        
                            }
                        })
                    break;

                    case 25:
                        this.dadosAgenda.map(dado => {
                            if(dado.idAgenda == data.dados.msg){
                                var  varDadosAgenda =  {
                                    dados : {
                                        msg: dado.nome,
                                        menu: data.dados.menu,
                                        input: data.dados.input,
                                        finalizou: data.dados.finalizou
                                        },
                                    id: data.id,
                                    resposta: data.resposta,
                                    sala: data.sala
                                }
                                this.menssagens.push(varDadosAgenda)

                            }
                        })
                    break;

                    case 33:
                        this.tipoExame.map(dado => {
                            if(dado.id == data.dados.msg){
                                var  varTipoExame =  {
                                    dados : {
                                        msg: dado.descricao,
                                        menu: data.dados.menu,
                                        input: data.dados.input,
                                        finalizou: data.dados.finalizou
                                        },
                                    id: data.id,
                                    resposta: data.resposta,
                                    sala: data.sala
                                }
                                this.menssagens.push(varTipoExame)

                            }
                        })
                    break;

                    case 34:
                        this.dadosAgenda.map(dado => {
                            if(dado.idAgenda == data.dados.msg){
                                let msgText = '<p>Médico: <strong>' + dado.nome + '</strong></p>';
                                msgText += '<p> Unidade: ' + dado.unidade.descricao + '</p>';
                                msgText += '<p> End: ' + dado.unidade.logradouro+', ' + dado.unidade.numeroLogradouro + ' - ' + dado.unidade.bairro + '</p>';
                                var  varDadosAgenda =  {
                                    dados : {
                                        msg: msgText,
                                        menu: data.dados.menu,
                                        input: data.dados.input,
                                        finalizou: data.dados.finalizou
                                        },
                                    id: data.id,
                                    resposta: data.resposta,
                                    sala: data.sala
                                }
                                this.menssagens.push(varDadosAgenda)

                            }
                        })
                    break;

                    default:
                        this.menssagens.push(data)
                }

            }else{//Menssagens lado Bot
                this.menssagens.push(data)
            }
        },

        escutarMensagens(){
            this.socket.on('sendMsg-bot', async (data)=>{

                //this.menssagens.push(data)
                this.pushMenssagens(data);

                console.log("escutarMessagens")
                console.log(data)

                if(data.dados.finalizou == true){
                    this.campo = 100;
                }
                
                this.salvarDadosPaciente(data.dados.tipoX, data.dados.tipoXMenu, data.dados.cliente)

                if(!data.id){
                    this.disabled = false
                    this.loading = false
                    this.resposta = ""
                }

                //seta o scroll pra ultima posicao que seria a msg mais atual
                var div = await document.getElementById("messageDisplay");
                div.scrollTop = div.scrollHeight - div.clientHeight;
            })
        },
        enviarResposta(param){
            console.log('CAMPOS: ', this.campo)
            this.disabled = true;
            this.resposta = param;
            this.resposta2 = param;
            this.resposta3 = param;

            let dadosBot = this.menssagens[this.menssagens.length - 1]
            //pega a ultima msg, pra comparar se no array de msg com as respostas, aquela resposta que o usuario mandou é valida

      

            this.salvarDadosTemporarios(dadosBot.dados.menu, dadosBot)

            let dados_ =  this.gerarParametrosDados(param, dadosBot.dados.menu, param, dadosBot.dados.finalizou)

            console.log("Enviar Resposta", dados_)
            console.log(dados_)
            


            let json = {
                resposta: param, //campo que o bot processa informacao
                id: this.dadosConexao.id,
                sala: this.dadosConexao.sala,
                dados: dados_
            }

            this.socket.emit('sendMsg-bot', json, function () {})

            this.loading = true

            if(this.caminho == 0){
                this.caminho = param;
            }
            
            if(this.caminho != 0){
                this.cont ++;

                
                // Sintomas de Covid
                if(this.caminho == 1){
                    switch (this.cont) {
                        case 1:
                            this.valorMask = '##/##/####'
                            this.masked = true                
                            this.placeholder = '00/00/0000'
                            this.resposta2 = "";
                            this.campo = 2;                                                                       
                            break;
                        case 2:
                            this.valorMask = '###.###.###-##'
                            this.masked = false
                            this.placeholder = '000.000.000-00'
                            this.resposta2 = ""
                            break;
                        case 3:
                            // this.yesHoNo = true;
                            this.campo = 1;
                            break;
                        case 14:
                            /* this.yesHoNo = true;
                            this.voltarShow = true */
                            this.campo = 100
                            break;
                    
                        default:
                            break;
                    }
                }
                       

                // Cancelar Consultas
                if(this.caminho == 4){
                    switch (this.cont) {
                        case 1:
                            this.valorMask = '###.###.###-##';
                            this.masked = false;
                            this.placeholder = '000.000.000-00';
                            this.resposta2 = ""
                            this.campo = 2;
                            break;
                        case 2:
                            this.valorMask = '##/##/####';
                            this.masked = true;
                            this.placeholder = '00/00/0000';
                            this.resposta2 = ""
                            break;
                        case 3:
                            this.valorMask = '##########';
                            this.masked = true;
                            this.placeholder = '0000000000';
                            this.resposta2 = ""
                            break;
                        case 4:
                            /* this.yesHoNo = true;
                            this.voltarShow = true */
                            this.campo = 100;
                            break;
                    
                        default:
                            break;
                    }
                }

                // Cancelar Exames
                if(this.caminho == 5){
                    switch (this.cont) {
                        case 1:
                            this.valorMask = '###.###.###-##';
                            this.masked = false;
                            this.placeholder = '000.000.000-00';
                            this.resposta2 = ""
                            this.campo = 2;
                            break;
                        case 2:
                            this.valorMask = '##/##/####';
                            this.masked = true;
                            this.placeholder = '00/00/0000';
                            this.resposta2 = ""
                            break;
                        case 3:
                            this.valorMask = '##########';
                            this.masked = true;
                            this.placeholder = '0000000000';
                            this.resposta2 = ""
                            break;
                        case 4:
                            // this.yesHoNo = true;
                            // this.voltarShow = true
                            this.campo = 100;
                            break;
                    
                        default:
                            break;
                    }
                }

                if(this.caminho == 6){
                    /* this.voltarShow = true
                    this.yesHoNo = true */
                    this.campo = 100;
                }
            }
        },

        salvarDadosPaciente(tipoCE, tipoMenu, dados){
            console.log('TIPOS: ', tipoCE, tipoMenu)
            if(tipoCE == "Consulta"){
                switch(tipoMenu){
                    case 1:
                        this.valorMask = '###.###.###-##';
                        this.masked = false;
                        this.placeholder = '000.000.000-00';
                        this.resposta2 = "";
                        this.campo = 2;
                        break;

                    case 2:
                        this.valorMask = '##/##/####';
                        this.masked = true;
                        this.placeholder = '00/00/0000';
                        this.resposta2 = ""
                        
                        this.dadosBot.idadeCliente = dados.idade;                        
                        //this.paciente.idEspecialidade = data.dados.cliente.;
                        this.dadosBot.nome = dados.nome;
                        this.paciente.idCliente = dados.usuario.id;
                        this.dadosBot.idCliente = dados.usuario.id;
                        this.dadosBot.cdPessoaFisica = dados.id;
                        this.dadosBot.sexo = dados.sexo;
                        this.dadosBot.dataNascimento = dados.dataNascimento;
                        break;

                    case 3:
                        this.dadosBot.codigoCarteirinha = dados.carteirinha.codigoCarteirinha;
                        this.dadosBot.idEmpresa = dados.carteirinha.idEmpresa;

                        this.campo = 3;    
                        break;

                    case 4:
                        this.listaEspecialidade = dados;
                        this.campo = 5;
                        this.valorMask = '######';
                        this.masked = false;
                        this.placeholder = '000000';
                        this.resposta2 = "";

                    
                        let msg_a = '<html>' ;
                        msg_a +='<table class="table"> <thead> <tr> <th scope="col">Cod</th> <th scope="col">Procedimentos</th>  </tr>  </thead>  <tbody>';
                        for(let item of this.listaEspecialidade) {
                            msg_a +='<tr>  <td>' + item.id + '</td>';
                            msg_a +='<td>' + item.descricao + '</td> </tr>';
                        }
                        msg_a +='</table>'
                        msg_a +='</html'

                        var a =  {dados : {
                                msg:msg_a,
                                menu: 24,
                                input: '',
                                finalizou: false
                        }}
                        // this.menssagens.push(a)
                    
                        break;

                    case 5:
                        this.resposta2 = "";
                        this.dadosAgenda = dados;
                        this.campo = 6;
                   
                        let msg_b = '<html>' ;
                        msg_b +='<table class="table"> <thead> <tr> <th scope="col">Cod</th> <th scope="col">Médicos</th>  </tr>  </thead>  <tbody>';
                        for(let item of this.dadosAgenda) {
                            msg_b +='<tr>  <td>' + item.idAgenda + '</td>';
                            msg_b +='<td>' + item.nome + '</td> </tr>';
                        }
                        msg_b +='</table>'
                        msg_b +='</html'

                        var b =  {dados : {
                                msg:msg_b,
                                menu: 25,
                                input: '',
                                finalizou: false
                        }}
                        // this.menssagens.push(b)
                        break;
                    
                    case 6:
                        this.valorMask = '##/##/####';
                        this.masked = true;
                        this.placeholder = '00/00/0000';
                        this.resposta2 = "";
                        this.datasGeral = dados;
                        this.campo = 7;

                        let msg_c = "";
                        let ultimaData;

                        dados.map( dh => {
                            // console.log(dh.data2.substr(0, 10));
                            if(this.datasDisponiveisAgenda){

                                //pega a ultima msg, pra comparar se no array de msg com as respostas, aquela resposta que o usuario mandou é valida
                                ultimaData = this.datasDisponiveisAgenda[this.datasDisponiveisAgenda.length - 1]
                                
                                if(ultimaData != dh.data2.substr(0, 10)){
                                    this.datasDisponiveisAgenda.push(dh.data2.substr(0, 10))
                                }
                                
                            }else{
                                this.datasDisponiveisAgenda = dh.data2.substr(0, 10);
                            }
                        })


                        this.datasDisponiveisAgenda.map(dh2 => {
                            msg_c += '<p>' + dh2 + '</p>';
                        })

                        var c =  {dados : {
                                msg:msg_c,
                                menu: 26,
                                input: '',
                                finalizou: false
                        }}
                        // this.menssagens.push(c)
                        break;

                    case 7:
                        this.valorMask = '##:##';
                        this.masked = true;
                        this.placeholder = '00:00';
                        this.resposta2 = "";
                        this.campo = 8;


                        // this.dataSelecionada = param;

                        this.datasGeral.map(dado =>{
                            if(this.dadosBot.dataSelecionada == dado.data2.substr(0, 10)){
                                this.horaDia.push(dado.data2.substr(11, 5))
                            }
                        })

                        let msg_e;

                        this.horaDia.map(hora =>{
                            msg_e += '<p>' + hora + '</p>'
                        })

                        var e =  {dados : {
                            msg:msg_e,
                            menu: 27,
                            input: '',
                            finalizou: false
                        }}
                        // this.menssagens.push(e)
                        

                        break;
                }
            }
            
            if(tipoCE == "Exame"){
                switch(tipoMenu){
                    case 1:
                        this.valorMask = '###.###.###-##';
                        this.masked = false;
                        this.placeholder = '000.000.000-00';
                        this.resposta2 = "";
                        this.campo = 2;
                    break;
                    
                    case 2:
                        this.valorMask = '##/##/####';
                        this.masked = true;
                        this.placeholder = '00/00/0000';
                        this.resposta2 = ""
                        
                        this.dadosBot.idCliente = dados.id;
                        this.dadosBot.idadeCliente = dados.idade;  
                    break;
                    
                    case 3:
                        this.dadosBot.codigoCarteirinha = dados.carteirinha.codigoCarteirinha;
                        this.dadosBot.idEmpresa = dados.carteirinha.idEmpresa;     
                        this.tipoExame = dados.agendaDisponiveis;
                        this.campo = 9;

                        // this.campo = 3;
                    break;

                    case 4:
                        this.resposta2 = "";
                        this.dadosAgenda = dados;
                        this.campo = 6;
                    break;
                    case 5:
                        this.resposta2 = "";
                        // this.horaDia = dados;
                        this.campo = 8;


                        dados.map(dado =>{
                            // this.horaDia.push(dado.data.substr(11, 5))
                            this.horaDia.push(dado.data)
                        })
                    break;
                }
            }

            if(tipoCE == "Sintomas Leves"){
                console.log('Caindo no sintomas leves', tipoMenu)
                switch(tipoMenu){
                    case 1:
                        this.valorMask = '###.###.###-##';
                        this.masked = false;
                        this.placeholder = '000.000.000-00';
                        this.resposta2 = "";
                        this.campo = 2;
                        break;

                    case 2:
                        this.valorMask = '##/##/####';
                        this.masked = true;
                        this.placeholder = '00/00/0000';
                        this.resposta2 = ""
                        
                        this.dadosBot.idadeCliente = dados.idade;                        
                        //this.paciente.idEspecialidade = data.dados.cliente.;
                        this.dadosBot.nome = dados.nome;
                        this.paciente.idCliente = dados.usuario.id;
                        this.dadosBot.idCliente = dados.usuario.id;
                        this.dadosBot.cdPessoaFisica = dados.id;
                        this.dadosBot.sexo = dados.sexo;
                        this.dadosBot.dataNascimento = dados.dataNascimento;
                        break;

                    
                }
            }
        },

        salvarDadosTemporarios(menu, dados){
            //funcao que guarda os dados que o usuario digitou, caso precise usar posteriormente

            switch (menu) {

                case 0:
                    this.cliente = null;
                    this.dadosBot = {
                                        tipo: null,
                                        dataNascimento: "",
                                        cpf: "",
                                        nome: ""
                                    }
                    break;
                /************MENU AGENDAR CONSULTA********* */
                case 21:
                    this.dadosBot.cpf = this.resposta
                    break;
                case 22:                 
                    break;
                case 23:
                    this.dadosBot.tele_and_presencial = this.resposta
                    break;
                case 24:
                    this.dadosBot.especialidade = this.respostaSelect;
                    break;
                case 25:
                    this.dadosBot.idAgenda = this.resposta; //Valor estatico, mudar depois

                    this.dadosAgenda.map( agenda => {

                        if(agenda.idAgenda == this.resposta){
                             this.dadosBot.idProfissional =  agenda.id;
                             this.dadosBot.dataAgenda = agenda.dataAgenda
                             this.dadosBot.nomeMedico = agenda.nome
                        }
            
                    } )                   
                    break;
                case 26:
                    this.dadosBot.dataSelecionada = this.resposta;
                    // this.dadosBot.dataHora = this.moment(this.resposta).format('YYYY/MM/DD');
                    this.dadosBot.dataHora = this.resposta.substr(6, 4) + "/" + this.resposta.substr(3, 2) + "/" + this.resposta.substr(0, 2)
                    break;
                case 27:
                    this.dadosBot.horaSelecionada = this.resposta;
                    this.dadosBot.dataHora = this.dadosBot.dataHora + " " + this.dadosBot.horaSelecionada;
                    this.dadosBot.disponivelApartirDe = "";
                    break;


                /************MENU AGENDAR EXAMES********* */
                case 31:
                    this.dadosBot.cpf = this.resposta
                    break;
                case 32:
                    this.dadosBot.dataNascimento = this.resposta;
                    break;
                case 33:
                    this.tipoExame.map(dado => {
                        if(dado.id == this.resposta){
                            this.dadosBot.exameId = this.resposta;
                            this.dadosBot.exameDescricao = dado.descricao;
                            this.dadosBot.exameDescricaoPreparo = dado.descricaoPreparo;
                        }                        
                    })
                    break;
                case 34:
                    this.dadosAgenda.map( dado => {
                        if(dado.idAgenda == this.resposta){
                            this.dadosBot.idAgenda = dado.idAgenda;
                            this.dadosBot.nomeMedico = dado.nome;
                            this.dadosBot.idProfissional = dado.id; 
                        }
                    })
                    this.dadosBot.disponivelApartirDe = "";
                    break;

                case 35:
                    this.dadosBot.dataAgenda2 = this.resposta;
                    /* this.dadosAgenda.map(dado =>{
                        if(dado.idAgenda == this.resposta){
                        }
                    }) */
                    break;

                
                    


                /************MENU CANCELAR CONSULTA********* */
                case 41:
                    //salva o cpf
                       this.dadosBot.cpf = this.resposta
                    break;

                case 42:
                    //salva a data de nascimento
                        this.dadosBot.dataNascimento = this.resposta
                    break;

                case 43:
                        this.cliente = dados.dados.cliente
                    break;

                 /************MENU CANCELAR EXAME********* */
                case 51:
                    //salva o cpf
                       this.dadosBot.cpf = this.resposta
                    break;

                case 52:
                    //salva a data de nascimento
                        this.dadosBot.dataNascimento = this.resposta
                    break;

                case 53:
                        this.cliente = dados.dados.cliente
                    break;

                /************MENU COVID********* */
                case 11:
                    this.dadosBot.dataNascimento = this.resposta
                    break;

                case 12:
                    this.dadosBot.cpf = this.resposta
                    this.dadosBot.tipo = 1
                    break;
                
                case 13:
                    this.dadosBot.nome = this.resposta
                    this.dadosBot.tipo = 2
                    break;

                case 14:
                    this.cliente = dados.dados.cliente
                    if(this.resposta == 1 || this.resposta == 2){
                        //zera a lista, tira o lixo
                        this.dadosCovid = []
                        //vai inserindo as respostas
                        this.dadosCovid.push({tipo:1, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 15:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:2, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 16:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:3, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 17:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:4, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 18:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:5, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 19:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:6, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 111:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:7, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 112:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:8, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                case 113:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:9, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;

                 case 114:
                    if(this.resposta == 1 || this.resposta == 2){
                        this.dadosCovid.push({tipo:10, valor: Number(this.resposta)})
                        //console.log(this.cliente, this.dadosCovid)
                    }
                    break;
                
                /************MENU SITOMAS LEVES********* */
                case 71:
                    this.dadosBot.cpf = this.resposta
                    break;
                case 72:                 
                    break;
                case 73:
                    this.dadosBot.tele_and_presencial = this.resposta
                    break;
                
            
                default:
                    break;
            }

        },
        gerarParametrosDados(msg, menu, input, finalizou){

            let retorno = null

            switch (menu) {
                case 21:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;
                case 22:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;
                case 23:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;
                case 24:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;
                case 25:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;
                case 26:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;
                case 27:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }
                    break;

                case 31:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 32:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;
                
                case 33:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 34:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 35:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;
                

                case 42:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 43:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.cliente                    
                    }           
                    break;

                case 52:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot                    
                    }                    
                    break;

                case 53:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.cliente                    
                    }           
                    break;

                case 12:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 13:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosBot
                    }                    
                    break;

                case 114:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        params:  this.dadosCovid,
                        cliente: this.cliente ? this.cliente : this.dadosBot, //pergunta final, entao passa os dados do cliente (pode ser que seja utilizado no server)
                    }                    
                    break;

                case 115:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        cliente: this.cliente ? this.cliente : this.dadosBot //pergunta extra, entao passa o dados do cliente para ser usado no server                      
                    }                    
                    break;

                case 71:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        cliente: this.cliente ? this.cliente : this.dadosBot //pergunta extra, entao passa o dados do cliente para ser usado no server                      
                    }                    
                    break;

                case 72:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        cliente: this.cliente ? this.cliente : this.dadosBot //pergunta extra, entao passa o dados do cliente para ser usado no server                      
                    }                    
                    break;
                
                case 73:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou,
                        cliente: this.cliente ? this.cliente : this.dadosBot //pergunta extra, entao passa o dados do cliente para ser usado no server                      
                    }                    
                    break;
            
                default:
                    retorno = {
                        msg: msg,
                        menu: menu,
                        input: input,
                        finalizou: finalizou
                    }                    
                    break;
            }


            return retorno
        }
    },

     watch:{
         respostaSelectDadosAgenda(){
             this.dadosAgenda.map(dado => {
                 if(this.respostaSelectDadosAgenda == dado.idAgenda){
                     this.dadosBot.disponivelApartirDe = dado.dataAgenda;
                     
                    var div = document.getElementById("messageDisplay");
                    div.scrollTop = div.scrollHeight - div.clientHeight;
                 }
             });
         }
     }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.btninput{
    margin: 3px 5px 3px 5px;
    padding: 10px 17px 10px 17px;
    border-radius: 50px 50px 50px 50px;
    -moz-border-radius: 50px 50px 50px 50px;
    -webkit-border-radius: 50px 50px 50px 50px;
}

.rodape{
    width: 100%;
}

.chatbot{
    background: #f0f4f3;
}

.cabecalho{
    height: 60px;
    /*background: #ddd;*/
}
.lista-msg{
    list-style: none;
    display: block;
     width: 100%;
     padding: 0;
     height: 300px;
     overflow: auto;
     
}

.lista-item{
    width: 100%;
    padding: 0;
    margin: 0;
}

.text-bot{
    text-align: left;
    margin: 5px 8px 0px 8px;
    font-size: 20px;
    font-family: Roboto;
    /* background: #ebebeb none repeat scroll 0 0;
    border-radius: 3px;
    color: #646464;
    font-size: 14px;
    margin: 0;
    padding: 5px 10px 5px 12px;
    width: 100%; */
}
.text-tempo{
    color: #747474;
    display: block;
    font-size: 12px;
    margin: 8px 0 0;
}

.text-cliente{
    text-align: left;
    margin: 5px 8px 0px 8px;
    font-size: 20px;
    font-family: Roboto;
    /* background: #5cc6ba none repeat scroll 0 0;
    border-radius: 3px;
    font-size: 14px;
    margin: 0;
    color: #fff;
    padding: 5px 10px 5px 12px;
    width: 100%; */
}

.btn-inicial{
  background: #215a41;
  border: solid 1px #215a41;
  border-radius: 111px 111px 111px 111px;
  -moz-border-radius: 111px 111px 111px 111px;
 -webkit-border-radius: 111px 111px 111px 111px;
}

.btn-inicial:hover{
  background: #31805d;
  border: solid 1px #31805d;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
}

.btn-inicial:active{
  background: #31805d;
  border: solid 1px #31805d;
}

.inputEnviar{
    border-radius: 111px 111px 111px 111px;
    -moz-border-radius: 111px 111px 111px 111px;
    -webkit-border-radius: 111px 111px 111px 111px;
}

.btnEnviar{
    background: #215a41;
    border: solid 1px #215a41;
    border-radius: 111px 111px 111px 111px;
    -moz-border-radius: 111px 111px 111px 111px;
    -webkit-border-radius: 111px 111px 111px 111px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: 10px;
}
.btnEnviar:hover{
  background: #31805d;
  border: solid 1px #31805d;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.75);
}

.btnEnviar:active{
  background: #31805d;
  border: solid 1px #31805d;
}

#messageDisplay::-webkit-scrollbar {
    display: none;
}

</style>
